import React, { useState, useEffect } from 'react';
import { FaSearch } from "react-icons/fa";
import { useLocation, useNavigate } from 'react-router';
import { FaAngleLeft } from "react-icons/fa6";
import { useSelector } from 'react-redux';
import { getAddress, setDefaultAddress } from '../Services/Operations/ProductAPI';

const SearchLocation = () => {
    const [searchTerm, setSearchTerm] = useState("");
    const [suggestions, setSuggestions] = useState([]);
    const token = useSelector((state) => state.user.token);
    const user_id = useSelector((state) => state.user.userId);
    const [address, setAddress] = useState([]);
    const [locationError, setLocationError] = useState(null);
    const location = useLocation();
    const navigation = useNavigate();
    const { data } = location.state || {};
    //console.log("data : ", data);

    const fetchLocations = async (query) => {
        const url = `https://nominatim.openstreetmap.org/search?q=${query}&format=json&addressdetails=1&limit=5`;

        try {
            const response = await fetch(url);
            const data = await response.json();
            setSuggestions(data);
        } catch (error) {
            console.error("Error fetching locations:", error);
            setLocationError("Failed to fetch locations");
        }
    };

    const handleSearch = (event) => {
        //console.log(">>>>>")
        const input = event.target.value;
        setSearchTerm(input);
        //console.log("Input : ", input);
        if (input.length > 0) {
            fetchLocations(input);
        } else {
            setSuggestions([]);
        }
    };

    const handleLocationSelect = (location) => {
        const lat = location.lat;
        const lon = location.lon;
        navigation('/my-location', { state: { lat, lon } });

    };

    const handleUseGPS = () => {
        navigation('/my-location');
    };

    useEffect(() => {
        const fetchAddress = async () => {
            const formData = new FormData();
            formData.append("token", token);
            formData.append("user_id", user_id);

            for (let pair of formData.entries()) {
                //console.log(`${pair[0]}: ${pair[1]}`);
            }

            try {
                const response = await getAddress(formData);
                //console.log("Address details: ", response);
                setAddress(response);
            } catch (error) {
                console.error("Error fetching restaurant details:", error);
            }
        };
        fetchAddress();
    }, [token, user_id]);

    const handleAddress = () => {
        const longitude = 87.78345447;
        const latitude = 22.88759098;
        navigation('/', { state: { latitude, longitude } });
    };
    

    const handleDefaultAddress = async (id) => {
        const formData = new FormData();
        formData.append("token", token);
        formData.append("user_id", user_id);
        formData.append("address_id", id);

        for (let pair of formData.entries()) {
            console.log(`${pair[0]}: ${pair[1]}`);
        }

        try {
            const response = await setDefaultAddress(formData);
            console.log("Default Address : ", response);
            if(response.status === 200){
                navigation("/")
            }
        } catch (error) {
            console.error("Error fetching restaurant details:", error);
        }
    };

    return (
        <div style={styles.container}>
            <div style={styles.searchBar}>
                <FaAngleLeft onClick={() => navigation(-1)} />
                <input
                    type="text"
                    placeholder="Search your area..."
                    style={styles.input}
                    value={searchTerm}
                    onChange={handleSearch}
                />
                <FaSearch />
            </div>
            <div style={styles.suggestions}>
                {suggestions.map((location, index) => {
                    const [firstPart, ...rest] = location.display_name.split(', ');
                    const restOfAddress = rest.join(', ');

                    return (
                        <div
                            key={index}
                            onClick={() => handleLocationSelect(location)}
                            style={styles.suggestionItem}
                        >
                            <span style={{ fontWeight: 'bold' }}>{firstPart},</span><br />
                            <span>{restOfAddress}</span>
                        </div>
                    );
                })}
            </div>

            <div style={styles.gpsSection}>
                <p>Turning on Device Location will ensure accurate address and hassle-free delivery</p>
                <button style={styles.gpsButton} onClick={handleUseGPS}>Use GPS</button>
                {locationError && <p style={styles.error}>{locationError}</p>}
            </div>
            <div style={styles.popularPlaces}>
                <h3>Popular Places</h3>
                <button onClick={handleAddress} style={styles.locationButton}>Arambagh</button>
            </div>
            <div style={styles.savedAddresses}>
                <h3>Saved Addresses</h3>
                {address.map((adre) => (
                    <div style={{ width: "100%", position: "relative", marginBottom: "14px" }} key={adre.id} onClick={()=>{handleDefaultAddress(adre.id)}}>
                        <div className="address-option">
                            {adre.tag && (
                                <p style={{
                                    margin: "0px", fontWeight: "bold", fontSize: "15px",
                                    textTransform: "uppercase"
                                }}>{adre.tag}</p>
                            )}
                            {adre.house && <p style={{ margin: "0px" }}>{adre.house}</p>}
                            {adre.address && <p>{adre.address}</p>}
                        </div>
                        {data?.default_address_id === adre.id && (
                            <span style={{
                                position: "absolute", top: "24px", right: "2px",
                                color: "orangered", fontWeight: "bold", fontSize: "20px",
                            }}>(✓)</span>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

const styles = {
    container: { padding: '16px', fontFamily: 'Arial' },
    searchBar: {
        marginBottom: '16px', display: "flex",
        gap: "20px",
        alignItems: "center",
        justifyContent: "center",
    },
    input: { width: '100%', padding: '8px', fontSize: '16px', border: "none", outline: "none" },
    gpsSection: { background: '#e0f7e8', padding: '16px', marginBottom: '16px' },
    gpsButton: { padding: '8px 16px', background: '#4CAF50', color: 'white', border: 'none', cursor: 'pointer' },
    popularPlaces: { marginBottom: '16px' },
    locationButton: { padding: '8px 16px', background: '#e0e0e0', border: 'none', cursor: 'pointer' },
    savedAddresses: { marginBottom: '16px' },
    address: { padding: '8px', background: '#f5f5f5', marginBottom: '8px' },
    error: { color: 'red', marginTop: '8px' },
    suggestionItem: {
        padding: "5px 5px",
        borderBottom: "1px solid #e5e5e5"
    }
};

export default SearchLocation;
